'use strict';

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var _ = require('underscore');

var polyglot = require('../../utilities/polyglot').default;

var ButtonView = require('./button').default;

export default Marionette.View.extend({

  className: 'l-buttons',
  template: require('./templates/buttons.hbs'),
  regions: {
    left: '.l-buttons-left-button',
    right: '.l-buttons-right-button',
    book: '.l-buttons-book-button',
    update: '.l-buttons-update-button',
  },
  ui: {
    logo: '.l-buttons-logo',
  },

  initialize: function (options) {
    this.buttons = {};
    if (options.left) {
      this.buttons.left = options.left;
    }
    if (options.right) {
      this.buttons.right = options.right;
    }
    if (options.book) {
      this.buttons.book = options.book;
    }

    if (options.update) {
      this.buttons.update = options.update;
    }

    this.listenTo(Radio.channel('steps'), 'change:current', this.toggleButtons);
    this.listenTo(Radio.channel('steps'), 'change:enabled', this.toggleButtons);
  },

  onRender: function () {
    this.toggleButtons();
    var self = this;
    _.each(this.buttons, function (button, key) {
      self.getRegion(key).show(button);
    });

    if (window.SETTINGS.private_label) {
      this.hideLogo();
    }
  },

  toggleButtons: function () {
    _.each(this.buttons, function (button, key) {
      button.toggleVisibility();
    });
  },

  hideLogo: function () {
    this.ui.logo.hide();
  },

});
